import { hetsApi } from "@/apis/interceptor"
import { IActivityResponse, IPaginationParamV2, IResponse } from "@/types"

export const activitiesService = {
  getActivities: async (params: IPaginationParamV2): Promise<IResponse<IActivityResponse>> => {
    const response = await hetsApi.get<IResponse<IActivityResponse>>("/v1/activities", { params })
    return response.data
  },
}
